import { ReactElement, useState, useEffect } from 'react';
import { useTranslation } from 'next-i18next';
import { Link } from '@Hotels-at-Home/hah-fe-core/dist/components';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const BeddingSection = (): ReactElement => {
  const { t: tBedding } = useTranslation('', { keyPrefix: '$local.$beddingSection' });
  const { t: tLinks } = useTranslation('', { keyPrefix: '$local.$homePageLinks.$beddingSection' });
  const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Product data array for easier iteration
  const products = [
    {
      key: 'pillows',
      link: tBedding('pillows.link'),
      image: '/images/homepage/hp-pillows.webp',
      alt: tBedding('pillows.alt'),
      title: tBedding('pillows.title'),
      description: tBedding('pillows.description'),
    },
    {
      key: 'duvets',
      link: tBedding('duvets.link'),
      image: '/images/homepage/hp-duvets.webp',
      alt: tBedding('duvets.alt'),
      title: tBedding('duvets.title'),
      description: tBedding('duvets.description'),
    },
    {
      key: 'linens',
      link: tBedding('linens.link'),
      image: '/images/homepage/hp-linens.webp',
      alt: tBedding('linens.alt'),
      title: tBedding('linens.title'),
      description: tBedding('linens.description'),
    },
  ];

  const renderProductCard = (product: (typeof products)[0]) => (
    <Link href={product.link} className="column">
      <img
        src={product.image}
        alt={product.alt}
        className="product-image"
        loading="lazy"
        decoding="async"
        fetchPriority="low"
        width={420}
        height={280}
      />
      <div className="column-copy">
        <h2>{product.title}</h2>
        <p>{product.description}</p>
        <span className="btn-text">{tButton('shopNow')}</span>
      </div>
    </Link>
  );

  return (
    <section className="base-section bedding-section hp-section">
      {/* Bedding Section */}
      <div className="columns-wrap">
        <Link href={tLinks('beddingMain')} className="columns-intro" id="HP_bedding">
          <h2>{tBedding('beddingTitle')}</h2>
          <p>{tBedding('beddingDescription')}</p>
        </Link>

        {isMobile ? (
          <div className="swiper-container">
            <Swiper
              modules={[Navigation, Pagination]}
              spaceBetween={20}
              slidesPerView={1.2}
              navigation
              pagination={{ clickable: true }}
              className="bedding-swiper"
            >
              {products.map(product => (
                <SwiperSlide key={product.key}>{renderProductCard(product)}</SwiperSlide>
              ))}
            </Swiper>
          </div>
        ) : (
          <div className="columns-3col">
            {products.map(product => (
              <div key={product.key}>{renderProductCard(product)}</div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default BeddingSection;
